import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { GlobalContext } from "../../../Context/GlobalContext";
import { NOTEMESSAGE } from "../../../constants";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../Context/AuthContext";
import { StandaloneSearchBox } from "@react-google-maps/api";
import { capitalized, isNumberOnly, isValidArray } from "../../../Layout/Common/common";
import { FormikErrorMessage } from "../../../Layout/Common/fromikErrorMessage";
import { OtpVerificationPopup } from "./otpVerificationPopup";
import { useModalPopupManager } from "../../../Context/modelPopupContext";

export const UpdateAddressPopup = () => {
  const { userId } = useAuth();
  const inputGoogleRef = useRef(null);
  const [newAddress, setNewAddress] = useState(null);
  const [updateAddress, setUpdateAddress] = useState(null);
  const { shippingAddressOriginal, suburbList, countryList } = useContext(GlobalContext);
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const { sendAddressUpdateOTP } = useGlobalFunction();
  const [showOtp, setShowOtp] = useState(false);
  const inputsRef = useRef([]);
  const { registerModal } = useModalPopupManager();

  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
    }
  }, []);

  useEffect(() => {
    if (shippingAddressOriginal) {
      let address = shippingAddressOriginal ?? {};
      setNewAddress({
        shipTo: address.shipTo ?? "",
        address1: address.shipAddress1 ?? "",
        address2: address.shipAddress2 ?? "",
        address3: address.shipAddress3 ?? "",
        city: address.shipCity ?? "",
        suburb: address.suburb ?? "",
        state: address.shipState ?? "",
        postCode: address.shipZip ?? "",
        country: capitalized(address.shipCountry ?? "Australia"),
        phone: address.shipPhone ?? "",
        attentionTo: address.shipAttention ?? "",
        deliveryInst: address.deliveryInst ?? "",
        signRequired: address.signRequired ?? true,
        isResidential: address.isResidential ?? true,
        address: "",
      });
    }
  }, [shippingAddressOriginal]);

  const handleShow = () => {
    registerModal(modalInstance.current);
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };

  const handleSubmit = (values) => {
    setUpdateAddress(values);
    sendAddressUpdateOTP();
    setShowOtp(true);
    handleHide();
  };

  // const checkRequiredField = (isValid, errors) => {
  //   if (errors["deliveryInst"]) childSignRef.current.showAlert();
  // };
  const handleOnChangeField = (e, key, setFieldValue) => {
    setFieldValue(key, e.target.value);
  };
  const handleSuburbChange = (setFieldValue, suburb) => {
    if (suburb) {
      setFieldValue("state", suburb.state);
      setFieldValue("suburb", suburb.suburb);
      setFieldValue("postCode", suburb.postCode);
    }
  };

  const validationSchema = Yup.object().shape({
    shipTo: Yup.string().required("Recipient name is required"),
    address1: Yup.string().required("Address Line 1 is required"),
    // address2: Yup.string().required("Address Line 2 is required"),
    suburb: Yup.string().required("Suburb is required"),
    state: Yup.string().required("State is required"),
    attentionTo: Yup.string().required("Attention Name is required"),
    postCode: Yup.string()
      .required("ZIP code is required")
      .matches(/^\d{3,6}$/, "ZIP code is incorrect"),
    country: Yup.string().required("Country is required"),
    phone: Yup.string().required("Phone number is required"),
    signRequired: Yup.boolean(),
    deliveryInst: Yup.string().test("deliveryInst-required", "Delivery instruction is required", function (value) {
      const { signRequired } = this.parent;
      if (!signRequired && !value) {
        return false;
      }
      return true;
    }),
  });
  const setInuputRefs = (el) => {
    if (el && !inputsRef.current.includes(el)) {
      inputsRef.current.push(el);
    }
  };
  const handleKeyDown = (e, formik) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();

      const currentIndex = inputsRef.current.indexOf(e.target);
      const fieldName = e.target.name;
      const value = e.target.value;
      const isRequired = e.target.required;

      if (isRequired && !value) {
        formik.setFieldTouched(fieldName, true, true);
        formik.validateField(fieldName);
        return;
      }

      const nextInput = inputsRef.current[currentIndex + 1];
      if (nextInput) {
        setTimeout(() => {
          nextInput.focus();
        }, 0); // 🔥 important
      }
    }
  };

  const fillAddressFromGoogle = async (setFieldValue) => {
    const place = inputGoogleRef.current.getPlaces()[0];
    if (place.address_components) {
      let address = place.address_components;
      var street_number = address.find((addr) => addr.types.includes("street_number"));
      var route = address.find((addr) => addr.types.includes("route"));

      var suburb = address.find((addr) => addr.types.includes("locality"));
      var state = address.find((addr) => addr.types.includes("administrative_area_level_1"));
      var country = address.find((addr) => addr.types.includes("country"));
      var postCode = address.find((addr) => addr.types.includes("postal_code"));
      let address1 = [];
      if (street_number) address1.push(street_number["long_name"]);
      if (route) address1.push(route["long_name"]);
      let address1Val = isValidArray(address1) ? address1.join(", ") : address[0]["long_name"];
      setFieldValue("address1", address1Val ?? "");
      setFieldValue("suburb", suburb?.long_name ?? "");
      setFieldValue("state", state?.short_name ?? "");
      setFieldValue("postCode", postCode?.long_name ?? "");
      setFieldValue("country", country?.long_name ?? "");
      if (address1Val) return true;
      return false;
    }
  };

  const handleOnChange = (e, setFieldValue) => {
    const fieldName = e.target.name;
    const value = e.target.value.replace(/[^a-z0-9 ]/gi, "");
    setFieldValue(fieldName, value);
  };
  return (
    <>
      <div className="button-effect accHeader-btn mt-2 mt-md-0">
        <button type="button" className="btn btn-products theme-primary" onClick={handleShow}>
          Update Shipping Address
        </button>
      </div>
      <OtpVerificationPopup show={showOtp} address={updateAddress} onhide={() => setShowOtp(false)} />
      <div
        className="modal fade"
        id="addFavModal"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-animate-center">
          <div className="modal-content myacc-modal-content">
            <p className="order-status-close" data-bs-dismiss="modal" onClick={handleHide}>
              <i className="fa-regular fa-circle-xmark" />
            </p>
            <div className="modal-body p-0">
              <div className="product-found">
                <div className="product-found-title">
                  <span className="wes-shipping-truck" />
                  <h4>Shipping Address Update</h4>
                </div>
                <div className="commonPopup-body acc-shipping-update">
                  <div className="acc-shippingUpdate-title text-center">
                    <h5 className="fw-medium">Account Shipping Address Change</h5>
                    <p className="fs-14 fw-normal">
                      Please note: This is an <b>Account address update</b>. For one-time or temporary address changes,
                      please select 'Change Shipping Address' during the checkout process.
                    </p>
                  </div>
                  <div className="acc-shippingUpdate-content mt-5">
                    {newAddress && countryList && (
                      <Formik initialValues={newAddress} validationSchema={validationSchema} onSubmit={handleSubmit}>
                        {({ setFieldValue, errors, isValid, touched, values, ...formik }) => (
                          <Form noValidate>
                            <div className="shippChange-address">
                              <h3 className="fs-6 fw-semibold mb-3">Receiver Address</h3>

                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="shipTo"
                                      name="shipTo"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input ${
                                        touched.shipTo && errors.shipTo && "error-message"
                                      }`}
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                      type="text"
                                      placeholder=" "
                                      tabIndex={0}
                                      maxLength={30}
                                    />
                                    <label htmlFor="shipTo">
                                      Account/Company Name
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <ErrorMessage name="shipTo">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="phone"
                                      name="phone"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input ${
                                        touched.phone && errors.phone && "error-message"
                                      }`}
                                      type="text"
                                      placeholder=""
                                      tabIndex={1}
                                      onChange={(e) => setFieldValue("phone", isNumberOnly(e.target.value))}
                                    />
                                    <label htmlFor="phone">
                                      Phone Number
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <ErrorMessage name="phone">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <StandaloneSearchBox
                                      onLoad={(ref) => (inputGoogleRef.current = ref)}
                                      onPlacesChanged={async () => {
                                        let res = await fillAddressFromGoogle(setFieldValue);
                                        if (res) {
                                          formik.setFieldTouched("address1", true);
                                          formik.setFieldError("address1", undefined);
                                        }
                                      }}
                                    >
                                      <>
                                        <Field
                                          id="address1"
                                          name="address1"
                                          innerRef={setInuputRefs}
                                          onKeyDown={(e) => handleKeyDown(e, formik)}
                                          required={true}
                                          className={`form-control form-input ${
                                            touched.address1 && errors.address1 && "error-message"
                                          }`}
                                          type="text"
                                          placeholder=""
                                          tabIndex={2}
                                          onChange={(e) => handleOnChange(e, setFieldValue)}
                                        />

                                        <label htmlFor="address1">Address1</label>
                                        <ErrorMessage name="address1">
                                          {(msg) => <FormikErrorMessage message={msg} />}
                                        </ErrorMessage>
                                      </>
                                    </StandaloneSearchBox>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="address2"
                                      name="address2"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={false}
                                      className={`form-control form-input`}
                                      type="text"
                                      placeholder=""
                                      tabIndex={3}
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                    />
                                    <label htmlFor="address2">Address2</label>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="floating-input  mb-3">
                                    <Field
                                      type="text"
                                      id="suburb"
                                      name="suburb"
                                      disabled={false}
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input ${
                                        touched.suburb && errors.suburb && "error-message"
                                      }`}
                                      onChange={(e) => handleOnChangeField(e, "suburb", setFieldValue)}
                                      placeholder=""
                                    ></Field>
                                    <label htmlFor="suburb">
                                      Enter Suburb details
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <ErrorMessage name="suburb">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="floating-input  mb-3">
                                    <Field
                                      type="text"
                                      id="state"
                                      name="state"
                                      disabled={false}
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input ${
                                        touched.state && errors.state && "error-message"
                                      }`}
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                      placeholder=""
                                    ></Field>
                                    <label htmlFor="state">
                                      State
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <ErrorMessage name="state">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="postCode"
                                      name="postCode"
                                      disabled={false}
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      maxLength="10"
                                      className={`form-control form-input ${
                                        touched.postCode && errors.postCode && `error-message`
                                      }`}
                                      type="text"
                                      placeholder=""
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                    />
                                    <label htmlFor="postCode">
                                      ZIP Code <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <ErrorMessage name="postCode">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="floating-select choose-state mb-3">
                                    <label htmlFor="state">
                                      Country
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <Field
                                      as="select"
                                      id="country"
                                      name="country"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-select custom-select ${
                                        touched.state && errors.state ? "error-message" : ""
                                      }`}
                                      aria-label="Choose State"
                                    >
                                      {countryList &&
                                        countryList.map((item, index) => (
                                          <option
                                            style={{
                                              maxWidth: "200px",
                                              padding: "2px 10px",
                                            }}
                                            value={capitalized(item.country)}
                                          >
                                            {item.country}
                                          </option>
                                        ))}
                                    </Field>

                                    <ErrorMessage name="country">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="attentionTo"
                                      name="attentionTo"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input`}
                                      type="text"
                                      placeholder=""
                                      maxLength={30}
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                    />
                                    <label htmlFor="attentionTo">Shipping Attn To (Receiver Name)</label>
                                    <ErrorMessage name="attentionTo">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="floating-input mb-2 mb-lg-3">
                                    <Field
                                      id="deliveryInst"
                                      name="deliveryInst"
                                      innerRef={setInuputRefs}
                                      onKeyDown={(e) => handleKeyDown(e, formik)}
                                      required={true}
                                      className={`form-control form-input`}
                                      type="text"
                                      placeholder=""
                                      maxLength={30}
                                      onChange={(e) => handleOnChange(e, setFieldValue)}
                                    />
                                    <label htmlFor="deliveryInst">Delivery Instruction</label>
                                    <ErrorMessage name="deliveryInst">
                                      {(msg) => <FormikErrorMessage message={msg} />}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="formCheck-selection mb-2 mb-lg-3">
                                    <label htmlFor="residential">
                                      Is this a Residential Address
                                      <span className="gl-form-asterisk">*</span>
                                    </label>
                                    <div className="formCheck-selection-list">
                                      <div className="form-check custom-check">
                                        <div className="signature-req-input">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="isResidential"
                                            id="isResidential"
                                            value={true}
                                            innerRef={setInuputRefs}
                                            onKeyDown={(e) => handleKeyDown(e, formik)}
                                            checked={values.isResidential == true}
                                            onChange={() => setFieldValue("isResidential", true)}
                                          />
                                        </div>
                                        <label className="form-check-label" htmlFor="isResidential">
                                          Yes
                                        </label>
                                      </div>

                                      <div className="form-check custom-check">
                                        <div className="signature-req-input">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="isResidential"
                                            id="isNotResidential"
                                            value={false}
                                            innerRef={setInuputRefs}
                                            onKeyDown={(e) => handleKeyDown(e, formik)}
                                            checked={values.isResidential == false}
                                            onChange={() => setFieldValue("isResidential", false)}
                                          />
                                        </div>
                                        <label className="form-check-label" htmlFor="isNotResidential">
                                          No
                                        </label>
                                      </div>
                                    </div>

                                    {/* Custom styled error message */}
                                    <ErrorMessage name="residential">
                                      {(msg) => (
                                        <p className="formError-msgShow">
                                          <i className="fa-solid fa-circle-exclamation pr-2" /> {msg}
                                        </p>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="formCheck-selection mb-2 mb-lg-3">
                                    <label htmlFor="residential">
                                      Signature Required On Delivery
                                      <span className="gl-form-asterisk">*</span>
                                    </label>

                                    <div className="formCheck-selection-list">
                                      <div className="form-check custom-check">
                                        <div className="signature-req-input">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="signRequired"
                                            id="signatureIsRequired"
                                            value={true}
                                            innerRef={setInuputRefs}
                                            onKeyDown={(e) => handleKeyDown(e, formik)}
                                            checked={values.signRequired == true}
                                            onChange={() => setFieldValue("signRequired", true)}
                                          />
                                        </div>
                                        <label className="form-check-label" htmlFor="residentialOne">
                                          Yes
                                        </label>
                                      </div>

                                      <div className="form-check custom-check">
                                        <div className="signature-req-input">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="signRequired"
                                            id="signatureNotRequired"
                                            value={false}
                                            innerRef={setInuputRefs}
                                            onKeyDown={(e) => handleKeyDown(e, formik)}
                                            checked={values.signRequired == false}
                                            onChange={() => setFieldValue("signRequired", false)}
                                          />
                                        </div>
                                        <label className="form-check-label" htmlFor="residentialTwo">
                                          No
                                        </label>
                                      </div>
                                    </div>

                                    {/* Custom styled error message */}
                                    <ErrorMessage name="residential">
                                      {(msg) => (
                                        <p className="formError-msgShow">
                                          <i className="fa-solid fa-circle-exclamation pr-2" /> {msg}
                                        </p>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12 mt-3">
                              <div className="acc-shipp-confirmation">
                                <div className="form-check custom-check">
                                  <label className="form-check-label fw-normal" htmlFor="shippAllow">
                                    Please allow One business day for your details to be updated after submitting from.
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12 mt-3 acc-shipp-button">
                              <div className="popupBtns mt-4">
                                <div className="button-effect popupBtns-two">
                                  <button type="submit" className="btn btn-products theme-primary" ref={setInuputRefs}>
                                    Request Change
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-products btn-unavailable"
                                    data-bs-dismiss="modal"
                                    onClick={handleHide}
                                    ref={setInuputRefs}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
